/* eslint-disable react-hooks/exhaustive-deps */
// wijmo
import { faSearch } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import * as wjcCore from "@grapecity/wijmo"
import * as wjcGrid from "@grapecity/wijmo.grid"
import * as wjrGrid from "@grapecity/wijmo.react.grid"
import * as wjrGridFilter from "@grapecity/wijmo.react.grid.filter"
import dayjs from "dayjs"
import _ from "lodash"

import React, { useEffect, useState } from "react"
import { Button, Col, Container, Row, Table } from "react-bootstrap"
import CONSTANT from "../../constant"
import VALIDATE_CONSTANT from "../../constant/validateConstant"
import ETCService from "../../service/truckcontrol/Etc/etcService"
import {
  TETCDataGetListReq,
  T高速料,
} from "../../service/truckcontrol/Etc/TEtc"
import { TWijmoCellTemplateContext } from "../../type/wijmoComponents"

// import GridFooter from "../FlexGridWrapper/GridFooter"
import DateInput from "../InputWrapper/DateInput"
import NumberInput from "../InputWrapper/NumberInput"
import TextInput from "../InputWrapper/TextInput"
import LocalAlertComponent from "../LocalAlertComponent"
import { ModalOuter, TModalTypes } from "../Modal/ModalOuter"

import Spinner from "../Spinner"

/**
 * 高速料情報検索モーダル
 * @param {*} props
 * @return {*} reactNode
 */
const KosokuryoSearchModal: React.FC<
  Omit<TModalTypes, "title"> & {
    title?: string
    footer?: React.ReactNode
    syaban?: string
    zyomuin?: string
    ninusi?: string
    tumiDay?: string
    orosiDay?: string
    tumiName?: string
    oroshiName?: string
    zyutyuhaisyaID?: number
    idlist?: number[]
    setKosokuryo: (value: T高速料[]) => unknown
  }
> = (props) => {
  //#region [state]
  // 検索項目
  const [車番, set車番] = useState<string>()
  const [乗務員名, set乗務員名] = useState<string>()
  const [積日, set積日] = useState<string | null>()
  const [卸日, set卸日] = useState<string | null>()
  const [荷主名, set荷主名] = useState<string>()
  const [積地住所２, set積地住所２] = useState<string>()
  const [卸地住所２, set卸地住所２] = useState<string>()
  const [合計金額, set合計金額] = useState<number>()

  // Grid
  const [pageSize] = useState<number>(50)

  const [flexGrid, setFlexGrid] = useState<wjcGrid.FlexGrid>()

  // Spinner用
  const [isSpinnerShow, setIsSpinnerShow] = useState(false)

  // アラート用State
  const [AlertSource, setAlertSource] = useState<any>()
  //#endregion

  //#region [method]
  /**
   * collectionView作成用
   * @param data gridに入れるデータ
   * @param pageSize ページサイズ
   * @returns CollectionView
   */

  const createCollectionView = (data: Array<any>, pageSize: number) =>
    new wjcCore.CollectionView(data, {
      pageSize,
    })

  const [gridData, setGridData] = useState<{
    data: wjcCore.CollectionView
  }>({
    data: createCollectionView([], pageSize),
  })
  const gridInitialized = (grid: wjcGrid.FlexGrid) => {
    grid.itemsSource = gridData.data
    grid.formatItem.addHandler(formatItem)
    grid.cellEditEnded.addHandler(cellEditEnded)
    setFlexGrid(grid)
  }
  const cellEditEnded = (
    f: wjcGrid.FlexGrid,
    e: wjcGrid.CellRangeEventArgs
  ) => {
    const gridData: T高速料[] = f.collectionView.sourceCollection
    const binding = e.getColumn().binding as keyof T高速料

    switch (binding) {
      case "選択":
        const 高速料 = gridData
          .filter((d) => d.選択)
          .map((d) => d.金額)
          .reduce((prev, current) => prev + current)
        set合計金額(高速料)
        break
      default:
        break
    }
  }

  const formatItem = (f: wjcGrid.FlexGrid, e: wjcGrid.FormatItemEventArgs) => {
    const targetRow = e.getRow()
    const dataItem: T高速料 = targetRow.dataItem
    if (e.getRow().dataIndex !== -1) {
      if (dataItem.選択) {
        wjcCore.toggleClass(e.cell, "read-only-cell", true)
        return
      }
      // 別のIDが登録されている場合は灰色にする
      if (
        dataItem.受注配車ID != null &&
        dataItem.受注配車ID !== props.zyutyuhaisyaID
      ) {
        wjcCore.toggleClass(e.cell, "dummy-header-cell", true)
        return
      }
    }
  }

  const search = async (searchCondition?: TETCDataGetListReq) => {
    setIsSpinnerShow(true)
    setAlertSource(undefined)
    if (flexGrid == null) return
    try {
      const res = await new ETCService().getKosokuryoList({
        車番: searchCondition?.車番,
        積日: searchCondition?.積日,
        卸日: searchCondition?.卸日,
      })
      if (res.data) {
        res.data.forEach((d) => {
          if (d.受注配車ID != null && d.受注配車ID === props.zyutyuhaisyaID) {
            d.選択 = true
          } else if (props.idlist && props.idlist.includes(d.高速料ID)) {
            d.選択 = true
          } else {
            d.選択 = false
          }
        })
        const newData = createCollectionView(
          [..._.orderBy(res.data, ["日付", "時刻"])],
          pageSize
        )
        flexGrid.itemsSource = newData
        flexGrid.refresh()
      }
    } catch (error) {
      setAlertSource(error)
    } finally {
      setIsSpinnerShow(false)
    }
  }

  /**
   * 選択ハンドラ
   */
  const submitHandler = () => {
    const item: T高速料[] =
      flexGrid?.collectionView.items.filter((d) => d.選択) ?? []
    props.setKosokuryo(item)
    props.setIsShow(false)
  }

  //#endregion

  //#region [effect]
  useEffect(() => {
    if (flexGrid == null) return

    if (props.isShow) {
      //表示時
      props.syaban != null && set車番(props.syaban)
      props.zyomuin != null && set乗務員名(props.zyomuin)
      props.tumiDay != null && set積日(props.tumiDay)
      props.orosiDay != null && set卸日(props.orosiDay)
      props.tumiName != null && set積地住所２(props.tumiName)
      props.oroshiName != null && set卸地住所２(props.oroshiName)
      props.ninusi != null && set荷主名(props.ninusi)
      if (props.syaban != null || props.tumiDay != null) {
        search({
          車番: props.syaban,
          積日: props.tumiDay,
          卸日: props.orosiDay,
        })
      }
    } else {
      // 非表示時中身を空にして閉じる
      set車番("")
      set乗務員名("")
      set積日("")
      set卸日("")
      set積地住所２("")
      set卸地住所２("")
      set荷主名("")
      const newData = {
        data: createCollectionView([], pageSize),
      }
      if (flexGrid != null) {
        flexGrid.itemsSource = newData.data
        flexGrid.refresh()
      }
      setGridData(newData)
    }
  }, [props.isShow, flexGrid])

  //#endregion
  return (
    <ModalOuter
      isShow={props.isShow}
      title={props.title ?? "高速料検索（ETC-GET）"}
      setIsShow={props.setIsShow}
      size={"xl"}
      footer={props.footer}>
      <Spinner inModal searching={isSpinnerShow}></Spinner>
      <Container fluid>
        {/* アラート表示 */}
        <Row>
          <Col>
            <LocalAlertComponent alertSource={AlertSource} />
          </Col>
        </Row>
        <form>
          <Row className="justify-content-center align-items-center">
            <Col>
              <Table className="search-table">
                <tbody>
                  <tr>
                    <td>
                      <div className="input-group">
                        <TextInput
                          style={{ width: "6rem" }}
                          id="車番"
                          name="車番"
                          placeholder="車番"
                          value={車番}
                          isReadOnly={true}
                          maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                          setValue={(v) => {
                            set車番(v)
                          }}></TextInput>
                        <TextInput
                          style={{ width: "10rem" }}
                          id="乗務員名"
                          name="乗務員名"
                          placeholder="乗務員名"
                          value={乗務員名}
                          isReadOnly={true}
                          maxLength={VALIDATE_CONSTANT.LENGTH.荷主コード}
                          setValue={(v) => {
                            set乗務員名(v)
                          }}></TextInput>
                      </div>
                    </td>
                    <td>
                      <TextInput
                        style={{ width: "20rem" }}
                        id="荷主名"
                        name="荷主名"
                        placeholder="荷主名"
                        maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                        value={荷主名}
                        isReadOnly={true}
                        setValue={(v) => {
                          set荷主名(v)
                        }}></TextInput>
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <DateInput
                        placeholder="積日"
                        value={積日}
                        isReadOnly={true}
                        setValue={(v) => {
                          set積日(v)
                        }}></DateInput>
                    </td>

                    <td>
                      <TextInput
                        style={{ width: "12rem" }}
                        id="積地住所２"
                        name="積地住所２"
                        value={積地住所２}
                        setValue={set積地住所２}
                        isReadOnly={true}
                        maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                        placeholder="積地"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <DateInput
                        placeholder="卸日"
                        value={卸日}
                        isReadOnly={true}
                        setValue={(v) => {
                          set卸日(v)
                        }}></DateInput>
                    </td>
                    <td>
                      <TextInput
                        style={{ width: "12rem" }}
                        id="卸地住所２"
                        name="卸地住所２"
                        value={卸地住所２}
                        setValue={set卸地住所２}
                        isReadOnly={true}
                        maxLength={VALIDATE_CONSTANT.LENGTH.一般名称}
                        placeholder="卸地住所２"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <Button
                        type="submit"
                        onClick={(e) => {
                          e.preventDefault()
                          search({
                            車番,
                            積日: 積日 ?? undefined,
                            卸日: 卸日 ?? undefined,
                          })
                        }}>
                        <FontAwesomeIcon icon={faSearch} />
                        検索
                      </Button>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </Col>
            <Col>
              <div className="w-100 h-100 text-center">
                <span className="fw-bold text-danger fs-5">
                  ※ETCデータはリアルタイム反映ではありません。
                </span>
              </div>
            </Col>
          </Row>
        </form>
        <Row>
          <Col>
            <wjrGrid.FlexGrid
              {...CONSTANT.GRID.PROPERTY_SET.FLEX_GRID_PROPS}
              keyActionTab={wjcGrid.KeyAction.None}
              selectionMode={wjcGrid.SelectionMode.Cell}
              initialized={gridInitialized}
              isReadOnly={false}>
              <wjrGridFilter.FlexGridFilter />
              <wjrGrid.FlexGridColumn
                binding="選択"
                width={60}
                isReadOnly={false}
                header="選択"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="日付"
                width={100}
                isReadOnly={true}
                header="日付">
                <wjrGrid.FlexGridCellTemplate
                  cellType="Cell"
                  template={(context: TWijmoCellTemplateContext<T高速料>) => {
                    let dt = ""
                    if (context.item.日付)
                      dt = dayjs(context.item.日付).format("MM/DD")
                    return <>{dt}</>
                  }}
                />
              </wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="時刻"
                width={80}
                isReadOnly={true}
                header="時刻"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={120}
                isReadOnly={true}
                header="利用IC（自）"
                binding="利用IC自"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                width={120}
                isReadOnly={true}
                header="利用IC（至）"
                binding="利用IC至"></wjrGrid.FlexGridColumn>
              <wjrGrid.FlexGridColumn
                binding="金額"
                width={140}
                isReadOnly={true}
                header="高速料（税込）"></wjrGrid.FlexGridColumn>
            </wjrGrid.FlexGrid>
          </Col>
        </Row>
        <Col>
          <Table className="form-table">
            <tbody>
              <tr>
                <th className="min-w-4rem">合計</th>
                <td>
                  <NumberInput
                    style={{ width: "6rem" }}
                    id="合計"
                    name="合計"
                    value={合計金額}
                    setValue={set合計金額}
                    readOnly={true}
                  />
                </td>
              </tr>
            </tbody>
          </Table>
        </Col>

        <Row className="search-button">
          <Col xl={{ span: "auto", offset: 0 }}>
            <Button
              type="submit"
              onClick={(e) => {
                e.stopPropagation()
                e.preventDefault()
                submitHandler()
              }}>
              選択
            </Button>
          </Col>
          <Col>
            <Button variant="secondary" onClick={() => props.setIsShow(false)}>
              一覧に戻る
            </Button>
          </Col>
        </Row>
      </Container>
    </ModalOuter>
  )
}

export default KosokuryoSearchModal
